import { configureSearchStore } from '@state';
import { initSearchQuerySync } from '@utils/search';
import React from 'react';
import { Provider } from 'react-redux';
import SearchContainer from './SearchContainer';
const store = configureSearchStore();
initSearchQuerySync(store);
const SearchApp = (props) => {
    return (React.createElement(Provider, { store: store },
        React.createElement(SearchContainer, Object.assign({}, props))));
};
export default SearchApp;
